import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "edit-quote-dialog" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-center nunito fw-bold fz-22 py-2 mb-3" }, "Edit Quote", -1);
const _hoisted_3 = { class: "d-flex flex-wrap mb-5" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("p", { class: "fz-20 py-2 mb-3 mx-3" }, "Pick a topic for your quote or write your own idea:", -1);
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "input-group mt-5" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "d-none input-group-text" }, "A quote about:", -1);
const _hoisted_8 = { class: "mx-auto w-100 text-center mt-4" };
const _hoisted_9 = {
    style: { "width": "32px", "padding": "5px 5px 5px 0px" },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000000",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};
const _hoisted_10 = /*#__PURE__*/ _createStaticVNode("<g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"><path d=\"M15 4V2\"></path> <path d=\"M15 16v-2\"></path> <path d=\"M8 9h2\"></path> <path d=\"M20 9h2\"></path> <path d=\"M17.8 11.8L19 13\"></path> <path d=\"M15 9h0\"></path> <path d=\"M17.8 6.2L19 5\"></path> <path d=\"M3 21l9-9\"></path> <path d=\"M12.2 6.2L11 5\"></path></g>", 3);
const _hoisted_13 = [
    _hoisted_10
];
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-chevron-double-left" }, null, -1);
import { ref } from 'vue';
import { useCalendarTemplatesStore } from '../stores/calendarTemplates';
import { useCalendarSettingsStore } from '../stores/calendarSettings';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditQuoteDialog',
    emits: ["closeDialog"],
    setup(__props, { emit }) {
        const calendarTemplatesStore = useCalendarTemplatesStore();
        const calendarSettingsStore = useCalendarSettingsStore();
        const currentPrompt = ref("");
        const topics = [
            { label: "January", prompt: "A quote about the month of January" },
            { label: "February", prompt: "A quote about the month of February" },
            { label: "March", prompt: "A quote about the month of March" },
            { label: "April", prompt: "A quote about the month of April" },
            { label: "May", prompt: "A quote about the month of May" },
            { label: "June", prompt: "A quote about the month of June" },
            { label: "July", prompt: "A quote about the month of July" },
            { label: "August", prompt: "A quote about the month of August" },
            { label: "September", prompt: "A quote about the month of September" },
            { label: "October", prompt: "A quote about the month of October" },
            { label: "November", prompt: "A quote about the month of November" },
            { label: "December", prompt: "A quote about the month of December" },
            { label: "Spring", prompt: "A quote about Spring" },
            { label: "Summer", prompt: "A quote about Summer" },
            { label: "Autumn", prompt: "A quote about Autumn" },
            { label: "Winter", prompt: "A quote about Winter" },
            { label: "F. Scott Fitzgerald", prompt: "A quote by F. Scott Fitzgerald" },
            { label: "Virginia Woolf", prompt: "A quote by Virginia Woolf" },
            { label: "George Orwell", prompt: "A quote by George Orwell" },
            { label: "Oscar Wilde", prompt: "A quote by Oscar Wilde" },
            { label: "Einstein", prompt: "A quote by Einstein" },
            { label: "Miguel de Cervantes", prompt: "A quote by Miguel de Cervantes" },
            { label: "Pablo Picasso", prompt: "A quote by Pablo Picasso" }
        ];
        const setPrompt = (prompt) => {
            currentPrompt.value = prompt;
        };
        const generateQuote = async () => {
            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            try {
                const response = await fetch('/generate-quote', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrfToken,
                    },
                    body: JSON.stringify({ prompt: currentPrompt.value }),
                });
                console.log(response);
                const data = await response.json();
                calendarSettingsStore.quote.text = JSON.parse(data.quote);
            }
            catch (error) {
                console.error("Error fetching quote:", error);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("button", {
                    type: "button",
                    class: "btn-close",
                    "aria-label": "Close",
                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('closeDialog')))
                }),
                _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", null, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(topics, (topic) => {
                            return _createElementVNode("span", {
                                key: topic.label,
                                class: "badge text-bg-secondary mx-1 my-1",
                                onClick: ($event) => (setPrompt(topic.prompt))
                            }, _toDisplayString(topic.label), 9, _hoisted_5);
                        }), 64))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((currentPrompt).value = $event))
                        }, null, 512), [
                            [_vModelText, currentPrompt.value]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                            class: "btn btn-secondary btn-md fz-20 mx-3 ps-3 pe-4",
                            style: { "border-radius": "5px" },
                            type: "button",
                            onClick: generateQuote
                        }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_13)),
                            _createTextVNode(" Generate Quote ")
                        ])
                    ])
                ]),
                _createElementVNode("button", {
                    type: "button",
                    class: "d-none btn btn-secondary btn-md mt-5 ms-2 fz-16 lh-24",
                    "aria-label": "Close",
                    onClick: _cache[2] || (_cache[2] = ($event) => (emit('closeDialog')))
                }, [
                    _hoisted_14,
                    _createTextVNode("Back to Settings ")
                ])
            ]));
        };
    }
});
